module.exports = __webpack_public_path__ + "9c55a2cd7ea79178ecb4f8a54bf73361.pdf";